import React, { FC, useMemo } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Stack, Tab, Tabs } from '@mui/material';

import { SourceType } from 'src/generated/mloop-graphql';

import SubscribersSelect from 'src/entities/SubscribersSelect';

import { ActivityFeedTabs as ActivityFeedTab } from './activityFeedFilters';

const ActivityFeedTabLabels = {
  [ActivityFeedTab.All]: 'hiring-dashboard-common:common.activity.allActivity',
  [ActivityFeedTab.Comments]: 'hiring-dashboard-common:common.activity.commentsOnly',
  [ActivityFeedTab.CandidateAction]: 'hiring-dashboard-candidates:candidates.activityFeed.candidateActionsOnly',
};

const BASE_TABS = [
  { id: ActivityFeedTab.All, label: ActivityFeedTabLabels[ActivityFeedTab.All] },
  { id: ActivityFeedTab.Comments, label: ActivityFeedTabLabels[ActivityFeedTab.Comments] },
];

const SUBSCRIBABLE_SOURCE_TYPES = [SourceType.SourceTypeTask];

type Props = {
  sourceId: string;
  sourceType: SourceType;
  value: ActivityFeedTab;
  onChange: (value: ActivityFeedTab) => void;
  showSubscribeButton?: boolean;
};

/**
 * Renders activity feed filters and optional subscriber controls.
 */
const ActivityFeedTabs: FC<Props> = ({ sourceId, sourceType, value, onChange, showSubscribeButton = true }) => {
  const { t } = useTranslation();
  const tabs = useMemo(() => {
    if (sourceType === SourceType.SourceTypeApplication) {
      return [
        ...BASE_TABS,
        { id: ActivityFeedTab.CandidateAction, label: ActivityFeedTabLabels[ActivityFeedTab.CandidateAction] },
      ];
    }

    return BASE_TABS;
  }, [sourceType]);

  return (
    <Stack direction="row" justifyContent="space-between">
      <Tabs value={value} onChange={(_, nextValue) => onChange(nextValue as ActivityFeedTab)}>
        {tabs.map((tab) => (
          <Tab key={tab.id} value={tab.id} label={t(tab.label)} />
        ))}
      </Tabs>

      {showSubscribeButton && SUBSCRIBABLE_SOURCE_TYPES.includes(sourceType) ? (
        <SubscribersSelect sourceId={sourceId} sourceType={sourceType} showSubscribeButton />
      ) : null}
    </Stack>
  );
};

export default ActivityFeedTabs;
